var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-title",class:['icon-title--' + _vm.size, 'icon-title--' + _vm.type],style:(_vm.customStyle)},[(_vm.icon || _vm.imgSrc)?[(_vm.icon && !_vm.imgSrc)?_c('i',{class:['icon-title__icon', _vm.icon],style:({ color: _vm.iconColor || _vm.textColor })}):_vm._e(),(_vm.imgSrc)?_c('img',{staticClass:"icon-title__img",style:({ 
        width: _vm.imgWidth,
        height: _vm.imgHeight,
        borderRadius: _vm.imgBorderRadius
      }),attrs:{"src":_vm.imgSrc,"alt":_vm.imgAlt || _vm.title}}):_vm._e()]:_vm._e(),_c('span',{staticClass:"icon-title__text",style:({ 
      color: _vm.textColor,
      fontSize: _vm.fontSize ? _vm.fontSize : null,
      fontWeight: _vm.isBold ? 'bold' : (_vm.fontWeight || null)
    })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.showDivider)?_c('div',{staticClass:"icon-title__divider",style:({ 
      backgroundColor: _vm.dividerColor,
      height: _vm.dividerHeight
    })}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }